import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c7158b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preschool-report-center" }
const _hoisted_2 = { class: "card nice-card mb-3 border-0 rounded-0 bg-white letter-spacing course-details-card" }
const _hoisted_3 = { class: "card-body p-10" }
const _hoisted_4 = { class: "bg-gradient ps-15 pe-15 pt-20 pb-20 ps-md-30 pe-md-30 pt-md-30 pb-md-30 ps-lg-40 pe-lg-40 pt-lg-40 pb-lg-40" }
const _hoisted_5 = { class: "course-details-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block bg-warning fs-12 fw-medium rounded-1 ps-10 pe-10 pt-1 pb-1 mb-10 text-black" }, " Preescolar - Basica - Media ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold text-white mb-6" }, "Centro de boletines", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lh-base fs-md-15 fs-lg-16 text-white-75 mb-12" }, [
  /*#__PURE__*/_createTextVNode(" Imprime o envía por email el reporte por "),
  /*#__PURE__*/_createElementVNode("b", null, "estudiante"),
  /*#__PURE__*/_createTextVNode(" o por "),
  /*#__PURE__*/_createElementVNode("b", null, "grupo"),
  /*#__PURE__*/_createTextVNode(". El sistema usa los estudiantes "),
  /*#__PURE__*/_createElementVNode("b", null, "matriculados"),
  /*#__PURE__*/_createTextVNode(" del año y grupo seleccionados. ")
], -1))
const _hoisted_9 = { class: "info d-sm-flex align-items-center justify-content-between gap-2" }
const _hoisted_10 = { class: "reviews d-flex align-items-center flex-wrap gap-2 mb-10 mb-sm-0 text-white" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"rating lh-1\" data-v-26c7158b><i class=\"flaticon-star-1\" data-v-26c7158b></i><i class=\"flaticon-star-1\" data-v-26c7158b></i><i class=\"flaticon-star-1\" data-v-26c7158b></i><i class=\"flaticon-star-1\" data-v-26c7158b></i><i class=\"flaticon-star-1\" data-v-26c7158b></i></div><span class=\"fw-bold fs-13\" data-v-26c7158b>Boletín</span><span class=\"opacity-85\" data-v-26c7158b>Reportes → Boletines</span>", 3)
const _hoisted_14 = { class: "badge rounded-pill bg-white text-dark ms-sm-2" }
const _hoisted_15 = {
  key: 0,
  class: "badge rounded-pill bg-info text-dark"
}
const _hoisted_16 = {
  key: 1,
  class: "badge rounded-pill bg-success text-white"
}
const _hoisted_17 = { class: "text-white fs-13 d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-85" }, "Matriculados:", -1))
const _hoisted_19 = { class: "fw-semibold" }
const _hoisted_20 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_21 = { class: "fw-semibold" }
const _hoisted_22 = { class: "mt-12 d-flex gap-2 flex-wrap" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-location" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-2" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock" }, null, -1))
const _hoisted_27 = { class: "card nice-card h-100" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-head-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-filter" }),
    /*#__PURE__*/_createTextVNode(" Filtros ")
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Rápidos y claros")
], -1))
const _hoisted_29 = { class: "card-body p-3" }
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Año académico", -1))
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Sede", -1))
const _hoisted_34 = { class: "mb-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Grupo", -1))
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Período", -1))
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, [
  /*#__PURE__*/_createTextVNode(" Estudiante (opcional) "),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-1 badge bg-light text-dark" }, "si vacío → imprime grupo")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nice-divider my-3" }, null, -1))
const _hoisted_41 = { class: "mb-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Salida", -1))
const _hoisted_43 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-printer" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-email-1" }, null, -1))
const _hoisted_46 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_47 = { class: "soft-box" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold" }, "Destinatarios"),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "por estudiante")
], -1))
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-1 me-1" }, null, -1))
const _hoisted_51 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1))
const _hoisted_53 = {
  key: 1,
  class: "text-danger mt-2 small"
}
const _hoisted_54 = { class: "card nice-card mb-3" }
const _hoisted_55 = { class: "card-head d-flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-head-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }),
    /*#__PURE__*/_createTextVNode(" Matriculados ")
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, " Basado en matrículas del año/grupo seleccionado (solo preescolar). ")
], -1))
const _hoisted_57 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-printer" }, null, -1))
const _hoisted_59 = { class: "ms-1 badge bg-light text-dark" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-email-1" }, null, -1))
const _hoisted_61 = { class: "ms-1 badge bg-light text-dark" }
const _hoisted_62 = { class: "card-body p-0" }
const _hoisted_63 = { class: "table-responsive" }
const _hoisted_64 = { class: "d-flex align-items-center gap-2" }
const _hoisted_65 = { class: "lh-sm" }
const _hoisted_66 = { class: "fw-semibold" }
const _hoisted_67 = { class: "d-flex gap-2 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.filters.DeliveryMode === 'PRINT' ? 'Salida: Imprimir' : 'Salida: Email'), 1),
                (_ctx.filters.StudentId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Modo: Estudiante "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, " Modo: Grupo "))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.enrollments.length || 0), 1),
                (_ctx.effectiveSelectedCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode(" · Seleccionados: "),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.effectiveSelectedCount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", {
                class: _normalizeClass(["chip", _ctx.filters.AcademicYearId ? 'chip-ok' : 'chip-warn'])
              }, [
                _hoisted_23,
                _createTextVNode(" " + _toDisplayString(_ctx.filters.AcademicYearId ? 'Año listo' : 'Seleccione año'), 1)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(["chip", _ctx.filters.HeadquarterId ? 'chip-ok' : 'chip-warn'])
              }, [
                _hoisted_24,
                _createTextVNode(" " + _toDisplayString(_ctx.filters.HeadquarterId ? 'Sede lista' : 'Seleccione sede'), 1)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(["chip", _ctx.filters.CourseGroupId ? 'chip-ok' : 'chip-warn'])
              }, [
                _hoisted_25,
                _createTextVNode(" " + _toDisplayString(_ctx.filters.CourseGroupId ? 'Grupo listo' : 'Seleccione grupo'), 1)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass(["chip", _ctx.filters.PeriodId ? 'chip-ok' : 'chip-warn'])
              }, [
                _hoisted_26,
                _createTextVNode(" " + _toDisplayString(_ctx.filters.PeriodId ? 'Período listo' : 'Seleccione período'), 1)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_row, { class: "g-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          lg: "4",
          xl: "3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_b_form, {
                  onSubmit: _withModifiers(_ctx.loadEnrollments, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.filters.AcademicYearId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.AcademicYearId) = $event)),
                        options: _ctx.academicYearsOptions,
                        placeholder: "Seleccione el año",
                        loading: _ctx.loading.lookups,
                        onChange: _ctx.onYearChanged,
                        required: ""
                      }, null, 8, ["modelValue", "options", "loading", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.filters.HeadquarterId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.HeadquarterId) = $event)),
                        options: _ctx.headquartersOptions,
                        placeholder: "Seleccione la sede",
                        loading: _ctx.loading.lookups,
                        onChange: _ctx.onHeadquarterChanged,
                        required: ""
                      }, null, 8, ["modelValue", "options", "loading", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.filters.CourseGroupId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.CourseGroupId) = $event)),
                        options: _ctx.courseGroupsOptions,
                        placeholder: "Seleccione el grupo",
                        loading: _ctx.loading.lookups,
                        onChange: _ctx.onGroupChanged,
                        required: ""
                      }, null, 8, ["modelValue", "options", "loading", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.filters.PeriodId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.PeriodId) = $event)),
                        options: _ctx.periodOptions,
                        placeholder: "Seleccione el período",
                        loading: _ctx.loading.lookups,
                        required: ""
                      }, null, 8, ["modelValue", "options", "loading"])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.filters.StudentId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.StudentId) = $event)),
                        options: _ctx.enrolledStudentsOptions,
                        placeholder: "(Opcional) seleccione estudiante",
                        loading: _ctx.loading.enrollments,
                        disabled: _ctx.enrollments.length === 0,
                        onChange: _ctx.onStudentChanged
                      }, null, 8, ["modelValue", "options", "loading", "disabled", "onChange"])
                    ]),
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_b_button, {
                          size: "sm",
                          variant: _ctx.filters.DeliveryMode === 'PRINT' ? 'primary' : 'outline-primary',
                          class: "pill-btn",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters.DeliveryMode = 'PRINT'))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_44,
                            _createTextVNode(" Imprimir ")
                          ]),
                          _: 1
                        }, 8, ["variant"]),
                        _createVNode(_component_b_button, {
                          size: "sm",
                          variant: _ctx.filters.DeliveryMode === 'EMAIL' ? 'success' : 'outline-success',
                          class: "pill-btn",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters.DeliveryMode = 'EMAIL'))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45,
                            _createTextVNode(" Enviar Email ")
                          ]),
                          _: 1
                        }, 8, ["variant"])
                      ])
                    ]),
                    (_ctx.filters.DeliveryMode === 'EMAIL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createVNode(_component_b_form_checkbox, {
                              modelValue: _ctx.emailOptions.SendToStudentEmail,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailOptions.SendToStudentEmail) = $event)),
                              class: "mb-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Email del estudiante ")
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_b_form_checkbox, {
                              modelValue: _ctx.emailOptions.SendToParentsEmail,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.emailOptions.SendToParentsEmail) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Email acudientes / padres ")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_b_button, {
                      type: "submit",
                      class: "w-100",
                      variant: "dark",
                      disabled: !_ctx.canSearch || _ctx.loading.enrollments
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.loading.enrollments)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                              _hoisted_50,
                              _createTextVNode(" Cargar matriculados")
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_51, [
                              _hoisted_52,
                              _createTextVNode(" Cargando... ")
                            ]))
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_b_button, {
                      type: "button",
                      class: "w-100 mt-2",
                      variant: "outline-secondary",
                      onClick: _ctx.clearAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Limpiar ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.errors.filters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.errors.filters), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          lg: "8",
          xl: "9"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_b_button, {
                    size: "sm",
                    variant: "outline-secondary",
                    class: "pill-btn",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAll(true))),
                    disabled: _ctx.enrollments.length === 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Seleccionar todo ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_b_button, {
                    size: "sm",
                    variant: "outline-secondary",
                    class: "pill-btn",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectAll(false))),
                    disabled: _ctx.enrollments.length === 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Limpiar selección ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_b_button, {
                    size: "sm",
                    variant: "primary",
                    class: "pill-btn",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.actionPrint())),
                    disabled: !_ctx.canRunPrint
                  }, {
                    default: _withCtx(() => [
                      _hoisted_58,
                      _createTextVNode(" Imprimir "),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.effectiveSelectedCount), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_b_button, {
                    size: "sm",
                    variant: "success",
                    class: "pill-btn",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.actionEmail())),
                    disabled: !_ctx.canRunEmail
                  }, {
                    default: _withCtx(() => [
                      _hoisted_60,
                      _createTextVNode(" Enviar "),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.effectiveSelectedCount), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_b_overlay, {
                  show: _ctx.loading.enrollments,
                  rounded: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_b_table, {
                        items: _ctx.enrollments,
                        fields: _ctx.fields,
                        responsive: "",
                        striped: "",
                        small: "",
                        class: "mb-0",
                        "empty-text": "No hay estudiantes matriculados con esos filtros."
                      }, {
                        "cell(sel)": _withCtx((row) => [
                          _createVNode(_component_b_form_checkbox, {
                            value: row.item.StudentId,
                            modelValue: _ctx.selectedStudentIds,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedStudentIds) = $event)),
                            disabled: !!_ctx.filters.StudentId && _ctx.filters.StudentId > 0
                          }, null, 8, ["value", "modelValue", "disabled"])
                        ]),
                        "cell(student)": _withCtx((row) => [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, _toDisplayString(row.item.StudentName), 1)
                            ])
                          ])
                        ]),
                        "cell(actions)": _withCtx((row) => [
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_b_button, {
                              size: "sm",
                              variant: "primary",
                              class: "pill-btn",
                              onClick: ($event: any) => (_ctx.actionPrint(row.item.StudentId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Imprimir ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_b_button, {
                              size: "sm",
                              variant: "success",
                              class: "pill-btn",
                              onClick: ($event: any) => (_ctx.actionEmail(row.item.StudentId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Email ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["items", "fields"])
                    ])
                  ]),
                  _: 1
                }, 8, ["show"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}